/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, addFavorited) {
    $.spinner().stop();
    console.log(data);
    if (data.success) {
        if (addFavorited) {
            $('#favoritesMessageModal .modal-title').text(data.title);
            $('#favoritesMessageModal .modal-body').text(data.msg);
            $('#favoritesMessageModal').modal('show');
            $('a.favoritesHeart').addClass('favorited');
            setTimeout(() => {
                $('#favoritesMessageModal').modal('hide');
            }, 5000);
        } else {
            $('a.favoritesHeart').removeClass('favorited');
        }

        if (data.totalItems) {
            $('.site-header .wishlist-quantity').text(data.totalItems);
        }
    }
}

module.exports = {
    addToWishlist() {
        $('body').on('click', 'a.favoritesHeart', function (e) {
            e.preventDefault();
            var url;
            var addFavorited = true;

            if ($(this).hasClass('favorited')) {
                url = $(this).data('url-favorite-remove');
                addFavorited = false;
            } else {
                url = $(this).data('url-favorite-add');
            }

            if ($(this).hasClass('guestUser')) {
                $('#favoritesGuestModal').modal('show');
                return;
            }

            var pid = $(this).closest('.product-detail').data('pid');
            var optionId = null;
            var optionVal = null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid,
                    optionId,
                    optionVal,
                },
                success(data) {
                    displayMessageAndChangeIcon(data, addFavorited);
                },
                error(err) {
                    displayMessageAndChangeIcon(err, addFavorited);
                },
            });
        });
    },
};
